import { useForm, Link } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function SignUp({ invitation, errors: serverErrors = {} }) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      organization_name: '',
      invitation_token: invitation?.token || '',
    },
  })

  const allErrors = { ...serverErrors, ...errors }

  function handleSubmit(e) {
    e.preventDefault()
    post('/sign_up')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-600">Gosellgo</h1>
          {invitation ? (
            <p className="mt-2 text-gray-600">
              Du har blivit inbjuden att gå med i <strong>{invitation.team_name}</strong> som {invitation.role}.
            </p>
          ) : (
            <p className="mt-2 text-gray-600">Skapa ditt konto och kom igång med er förening</p>
          )}
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            {!invitation && (
              <>
                <div className="pb-1 border-b border-gray-100">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Din organisation</p>
                </div>
                <FormField label="Organisationens namn" error={allErrors.organization_name}>
                  <input
                    type="text"
                    value={data.user.organization_name}
                    onChange={e => setData('user', { ...data.user, organization_name: e.target.value })}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="t.ex. Fotbollsklubben IF"
                    autoComplete="organization"
                  />
                </FormField>
                <div className="pt-1 pb-1 border-b border-gray-100">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Ditt konto</p>
                </div>
              </>
            )}

            <FormField label="Fullständigt namn" error={allErrors.name}>
              <input
                type="text"
                value={data.user.name}
                onChange={e => setData('user', { ...data.user, name: e.target.value })}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="name"
              />
            </FormField>

            <FormField label="E-post" error={allErrors.email}>
              <input
                type="email"
                value={data.user.email}
                onChange={e => setData('user', { ...data.user, email: e.target.value })}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="email"
              />
            </FormField>

            <FormField label="Lösenord" error={allErrors.password}>
              <input
                type="password"
                value={data.user.password}
                onChange={e => setData('user', { ...data.user, password: e.target.value })}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="new-password"
              />
            </FormField>

            <FormField label="Bekräfta lösenord" error={allErrors.password_confirmation}>
              <input
                type="password"
                value={data.user.password_confirmation}
                onChange={e => setData('user', { ...data.user, password_confirmation: e.target.value })}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="new-password"
              />
            </FormField>

            <Button type="submit" disabled={processing} className="w-full">
              {processing ? 'Skapar konto…' : 'Skapa konto'}
            </Button>
          </form>

          <p className="mt-6 text-center text-sm text-gray-600">
            Har du redan ett konto?{' '}
            <Link href="/sign_in" className="text-indigo-600 hover:underline">
              Logga in
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
